import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-termo-seguro',
    templateUrl: './termo-seguro.component.html',
    styleUrls: ['./termo-seguro.component.css'],
    imports: []
})
export class TermoSeguroComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
